import $ from 'jquery';

const identifyBreakpoint = (width = window.innerWidth) => {
  if (width < theme.breakpoints.tablet) { 
    return 'mobile';
  }

  if (width >= theme.breakpoints.tablet && width < theme.breakpoints.laptop) {
    return 'tablet';
  }

  if (width >= theme.breakpoints.laptop && width < theme.breakpoints.desktop) {
    return 'laptop';
  }
      
  return 'desktop';
};

let previous_breakpoint = identifyBreakpoint();

const breakpoints = () => {

  window.theme.breakpoints.current = previous_breakpoint;

  $(window).on('resize', () => {
    const current_breakpoint = identifyBreakpoint();

    if (current_breakpoint !== previous_breakpoint) {
      previous_breakpoint = current_breakpoint;
      window.theme.breakpoints.current = current_breakpoint;
      $(window).trigger('breakpointChange', current_breakpoint);
      // Fire a scroll event to trigger any animations that might need to happen on a breakpoint change
      $(window).trigger('scroll');
    }
  });

};

export { breakpoints };